// This code resolves exceptions in ag-grid-react's DeepValueStrategy.
// It falls back to shallow comparison.
//
// DeepValueStrategy in ag-grid-react throws an error when attempting to
// compare immutable objects. It tries to mutate the objects it's comparing,
// presumably to avoid infinite recursion. It tries to avoid mutation by
// starting the comparison with shallow copies, but it doesn't copy nested
// objects.

import {
  ChangeDetectionService,
  ChangeDetectionStrategy,
  ChangeDetectionStrategyType,
} from "ag-grid-react/lib/shared/changeDetectionService";
import { logger } from "./lib/Datadog";

const deepStrategy = new ChangeDetectionService().getStrategy(
  ChangeDetectionStrategyType.DeepValueCheck
);

const strategyMap: Record<
  ChangeDetectionStrategyType,
  ChangeDetectionStrategy
> = {
  [ChangeDetectionStrategyType.DeepValueCheck]: {
    areEqual: (a: any, b: any): boolean => {
      try {
        return deepStrategy.areEqual(a, b);
      } catch (err) {
        logger.warn("Ignoring DeepValueStrategy error when comparing", [
          a,
          b,
          err,
        ]);
        return a === b;
      }
    },
  },
  [ChangeDetectionStrategyType.IdentityCheck]: {
    areEqual: (a: any, b: any): boolean => a === b,
  },
  [ChangeDetectionStrategyType.NoCheck]: {
    areEqual: (a: any, b: any): boolean => false,
  },
};

export default function patchComparison() {
  ChangeDetectionService.prototype.getStrategy = (
    strategy: ChangeDetectionStrategyType
  ): ChangeDetectionStrategy => {
    return strategyMap[strategy];
  };
}
